module.exports = __webpack_public_path__ + "img/3b92cc4.png";